import {Segments} from '@superweb/ui'

import type {Tariff, TariffsCargoInfo} from '../../../../../../api'
import type {Resource} from '../../../../../../utils'
import {BlocksLayout} from '../../../Blocks/BlocksLayout@desktop'
import {CargoMapContainer} from '../../components/map-container/CargoMap@desktop.container'
import {useCargoInfoController} from '../../hooks'
import styleClasses from './classes.module.css'

export type InfoProps = {
  tariff: Tariff
  resource: Resource<TariffsCargoInfo>
}

export function CargoInfo({tariff, resource}: InfoProps) {
  const {tariffsInfo, mapPolygon} = resource.read()

  const {tabs, onTabValueChange, tabValue, blocks} = useCargoInfoController(tariffsInfo)
  return (
    <div className={styleClasses.cargoInfoWrapper}>
      <CargoMapContainer key={tariff.id} polygon={mapPolygon} />
      {tabs.length > 1 && (
        <div className={styleClasses.cargoInfoTabs}>
          <Segments onChange={onTabValueChange} options={tabs} size="l" value={tabValue} />
        </div>
      )}
      <BlocksLayout blocks={blocks} />
    </div>
  )
}
